export const KEYS = {
  DASH: '–',
};

export const LABELS = {
  BREADCRUMBS: [
    ['page.merchant.s4cUserBreadcrumbsMerchantAccounts', 'Merchant Accounts'],
    ['page.merchant.s4cUserBreadcrumbsAccountSettings', 'Account Settings'],
  ],
  PAGE_TITLE: ['pages.payout.view.title', 'Payout details'],
  SECTIONS: {
    DETAILS: {
      TITLE: ['page.payout.view.sections.details.title', 'Payout Details'],
      AMOUNT: ['page.payout.view.sections.details.amount', 'Amount'],
      CREATED_AT: ['page.payout.view.sections.details.createdAt', 'Created At'],
      SUBMITTED_AT: ['page.payout.view.sections.details.submittedAt', 'Submitted At'],
      PERIOD: ['page.payout.view.sections.details.period', 'Period'],
      PAYOUT_ID: ['page.payout.view.sections.details.id', 'Payout ID'],
      FROM: ['page.payout.view.sections.details.from', 'From: '],
      TO: ['page.payout.view.sections.details.to', 'To: '],
    },
    DESTINATION: {
      TITLE: ['pages.payout.view.sections.exchangeDetails.title', 'Payout Destination'],
      STATUS: ['pages.payout.view.sections.exchangeDetails.status', 'Status'],
      PAYMENT_RAIL: ['pages.payout.view.sections.exchangeDetails.paymentRail', 'Payment Rail'],
      BANK_ACCOUNT: ['pages.payout.view.sections.exchangeDetails.bankAccountName', 'Bank Account'],
      TRACE_ID: ['pages.payout.view.sections.exchangeDetails.traceId', 'Bank Transfer ID'],
      MESSAGE: ['pages.payout.view.sections.exchangeDetails.message', 'Bank Transfer Message'],
      DESTINATION_WALLET: ['pages.payout.view.sections.exchangeDetails.destinationWallet', 'Destination Wallet'],
      TRANSACTION_HASH: ['pages.payout.view.sections.exchangeDetails.transactionHash', 'Transaction Hash'],
      ACTIONS: {
        RETRY: ['pages.payout.view.sections.exchangeDetails.actions.retry', 'Retry Payout'],
      },
    },
    CUSTOMER: {
      TITLE: ['pages.payout.view.sections.customer.title', 'Customer'],
      CUSTOMER_EMAIL: ['pages.payout.view.sections.customer.userEmail', 'Customer Email'],
      CUSTOMER_ID: ['pages.payout.view.sections.customer.userId', 'Customer ID'],
      EXTERNAL_CUSTOMER_ID: ['pages.payout.view.sections.customer.externalUserId', 'External Customer ID'],
    },
    TOP_AREA: {
      PAYOUT_ID: ['pages.payout.view.sections.statusBar.id', 'Payout ID'],
      AMOUNT: ['pages.payout.view.sections.statusBar.amount', 'Amount'],
      STATUS: ['pages.payout.view.sections.statusBar.status', 'Status'],
    },
  },
  ERRORS: {
    RETRY_FAILED: ['pages.payout.view.sections.errors.retry', 'Retry Payout Failed'],
  },
};
